/** Rutas que deben servirse como archivo estático, no como rutas de la SPA */
export const STATIC_ASSET_EXT = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip|rar|7z|mp4|webm|mp3|wav|avi|mov|jpg|jpeg|png|gif|webp|svg|ico|txt|csv|xml|json)$/i

export function isStaticAssetPath(path) {
  const clean = String(path ?? '').split('?')[0].split('#')[0]
  return STATIC_ASSET_EXT.test(clean)
}
